import { HttpClient } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { apiList } from './apiList.service';
import { map } from 'rxjs/operators';
import {
  immediateVehiclePayload,
  immediateVehicleResponse,
} from '../models/immediateVehicle.model';

@Injectable({
  providedIn: 'root',
})
export class immediateVehicleService {
  private sharedData = signal<boolean | null>(null);
  private sharedSUpportData = signal<string | null>(null);
  private sharedDataImmediate = signal<boolean | null>(null);
  constructor(
    private readonly http: HttpClient,
    private _apiList: apiList
  ) {}

  setSupportPhone(newData: string) {
    this.sharedSUpportData.set(newData);
  }

  getSupportPhone() {
    return this.sharedSUpportData;
  }

  setData(newData: boolean) {
    this.sharedData.set(newData);
  }

  getData() {
    return this.sharedData;
  }

  setImmediateData(newData: boolean) {
    this.sharedDataImmediate.set(newData);
  }

  getImmediateData() {
    return this.sharedDataImmediate;
  }

  immediateVehicle(
    data: immediateVehiclePayload
  ): Observable<immediateVehicleResponse> {
    return this.http
      .post<{
        data: immediateVehicleResponse;
      }>(`${environment.base_url}${this._apiList.immediateVehicle}`, data)
      .pipe(map(res => res.data));
  }

  getImmediateRideSharingOptions(query: string): Observable<boolean> {
    return this.http
      .get<{
        data: boolean;
      }>(`${environment.base_url}${this._apiList.immediatesharing}?${query}`)
      .pipe(map(res => res.data));
  }
}
